import AdyenBtn from '../../adyen-button';
import './sepa-pay-button.scss';

const SepaPayBtn = () => {
    return <AdyenBtn
        className='sepa-pay-button'
        paymentType='sepadirectdebit'
    />;
};

export default SepaPayBtn;
